import React from 'react';

const Page404 = () => {
    return (
        <div className='container'>
            <h1>Page not found</h1>
            <h3>Invalid url</h3>
        </div>
    );
};

export default Page404;